import { use } from 'react';

import { ErrorBoundary } from '@/app/providers/error-boundary';
// import { Container } from '@/shared';
import { SubscriptionsResponseV1 } from '@/shared/api';

import { SubscriptionsList } from './subscriptions-list';

export type SubscriptionsProps = {
	data: Promise<SubscriptionsResponseV1>;
	children: (props: React.PropsWithChildren) => React.ReactNode;
	isPromoCodeValid?: boolean;
	promocode?: string;
};

export function Subscriptions({
	data,
	children,
	isPromoCodeValid,
	promocode,
}: SubscriptionsProps) {
	const subscriptions = use(data);

	return children({
		children: (
			<ErrorBoundary>
				<SubscriptionsList
					data={subscriptions}
					isPromoCodeValid={isPromoCodeValid}
					promocode={promocode}
				/>
			</ErrorBoundary>
		),
	});
}
